export default __webpack_public_path__ + "static/media/LoyaltyActive.dd91ac3d.svg";